<template>
	<article class="event">
		<form @submit.prevent="search()">
			<managing-section :column-count="2">
				<managing-box title="이벤트 구분">
					<RadioList
						v-model="eventType"
						value-name="name"
						:radio-list="getListAddNull('eventType')"
					/>
				</managing-box>
				<managing-box title="참여 조건">
					<RadioList
						v-model="prerequisiteType"
						value-name="name"
						:radio-list="getListAddNull('prerequisiteType')"
					/>
				</managing-box>
				<managing-box title="이벤트명">
					<input v-model="eventTitle" type="text" />
				</managing-box>
				<managing-box title="클라이언트" :horizontal-mode="true">
					<div class="event__filter__client">
						<selector
							v-model="clientType"
							:option-list="clientTypeList"
							value-key="id"
							class="event__filter__client__type"
							@input="valueChange('clientName', '')"
						/>
						<input
							v-if="clientType === 1"
							v-model="clientName"
							type="text"
						/>
						<search-brand
							v-else-if="clientType === 2"
							:prop-name="clientName"
							@change="
								valueChange('clientName', $event.brandTitle)
							"
						/>
					</div>
				</managing-box>
				<managing-box title="진행 여부">
					<RadioList
						v-model="progress"
						value-name="name"
						:radio-list="progressList"
					/>
				</managing-box>
				<managing-box title="상태">
					<RadioList
						v-model="isDisplay"
						value-name="name"
						:radio-list="isDisplayList"
					/>
				</managing-box>
				<managing-box title="이벤트기간">
					<DateRange v-model="eventDateRange" type="date" />
				</managing-box>
				<ManagingBox title="유형">
					<RadioList
						v-model="isHidden"
						valueName="name"
						:radioList="isHiddenList"
					/>
				</ManagingBox>
			</managing-section>
			<div class="btn-wrap-main">
				<button
					type="submit"
					class="btn-main blue"
					v-text="'검색하기'"
				/>
				<button
					type="button"
					class="btn-main"
					v-text="'검색조건 초기화'"
					@click="init"
				/>
			</div>
		</form>
		<managing-section :is-table="true">
			<template slot="infoSection">
				<div class="section__info__left">
					<p>
						<span class="event__total__item"
							>검색결과 : 전체 {{ totalItem }}건</span
						>
						<span
							v-for="(str, idx) in totalList"
							:key="idx"
							class="event__total__item event__total__item--sub"
							>{{ str }}</span
						>
					</p>
				</div>
				<div class="section__info__right">
					<selector
						v-model="order"
						:option-list="orderList"
						value-key="id"
						class="section__info__items"
						@input="search()"
					/>
					<selector
						v-model="limit"
						:option-list="limitList()"
						value-key="id"
						class="section__info__items"
						@input="search()"
					/>
					<button
						class="btn-excel section__info__items"
						@click="excelDownload"
					>
						엑셀 다운로드
					</button>
				</div>
			</template>
			<table class="table-main event__table">
				<thead>
					<tr>
						<th>번호</th>
						<th>등록일시</th>
						<th>유형</th>
						<th>구분</th>
						<th class="event__table__name">이벤트명</th>
						<th>참여조건</th>
						<th>클라이언트</th>
						<th>시작일시</th>
						<th>종료일시</th>
						<th>관리자명</th>
						<th>조회</th>
						<th>댓글</th>
						<th>당첨인원</th>
						<th>참여자수</th>
						<th>진행 여부</th>
						<th>상태</th>
						<th>삭제</th>
						<th>복제</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in list" :key="item.idEvent">
						<td>{{ item.idEvent }}</td>
						<td>{{ item.createdDate }}</td>
						<td>{{ item.isHidden }}</td>
						<td>{{ item.eventType }}</td>
						<td class="event__table__link">
							<router-link
								:to="`/events/modifies/${item.idEvent}`"
								class="link"
								>{{ item.eventTitle }}</router-link
							>
						</td>
						<td>{{ item.prerequisiteType }}</td>
						<td>{{ item.clientName }}</td>
						<td>{{ item.startDate }}</td>
						<td>{{ item.endDate }}</td>
						<td>{{ item.nickName }}</td>
						<td>{{ item.hitsCount }}</td>
						<td>{{ item.replyCount }}</td>
						<td>{{ item.winnerLimit }}</td>
						<td>{{ item.candidateCount }}</td>
						<td>{{ item.progress }}</td>
						<td>{{ item.isDisplay }}</td>
						<td>
							<button
								class="btn-delete"
								@click="deleting(item.idEvent)"
							>
								삭제
							</button>
						</td>
						<td>
							<button
								@click="
									duplicate(item.eventTitle, item.idEvent)
								"
								class="btn orange"
								v-text="'복제'"
							/>
						</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				slot="pagination"
				:total-item="totalItem"
				:limit="limit"
				:offset="offset"
				@to="search($event.offset)"
			/>
		</managing-section>
	</article>
</template>
<script>
	import { getIdRegister } from '@/util';
	import compact from 'lodash/compact';
	import moment from 'moment';
	import { mapGetters } from 'vuex';
	import Util from '@/util';
	import ManagingSection from '@/components/layout/ManagingSection';
	import ManagingBox from '@/components/layout/ManagingBox';
	import RadioList from '@/components/RadioList';
	import Selector from '@/components/Selector';
	import SearchBrand from '@/components/SearchBrand';
	import DateRange from '@/components/DateRange';
	import PaginationBox from '@/components/PaginationBox';

	export default {
		name: 'EventsList',
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			Selector,
			SearchBrand,
			DateRange,
			PaginationBox,
		},
		data() {
			const isHiddenList = [
				{ id: null, name: '전체' },
				{ id: 0, name: '일반' },
				{ id: 1, name: '히든' },
			];

			return {
				paramsKeys: [
					'eventType',
					'prerequisiteType',
					'eventTitle',
					'clientType',
					'clientName',
					'progress',
					'isDisplay',
					'eventDateRange',
					'isHidden',
					'offset',
					'order',
					'limit',
				],
				eventType: null,
				prerequisiteType: null,
				eventTitle: '',
				clientTypeList: [
					{ id: null, name: '전체' },
					{ id: 1, name: '자체 운영' },
					{ id: 2, name: '브랜드' },
				],
				clientType: null,
				clientName: '',
				progressList: [
					{ id: null, name: '전체' },
					{ id: 1, name: '진행예정' },
					{ id: 2, name: '진행 중' },
					{ id: 3, name: '종료' },
				],
				progress: null,
				isDisplayList: [
					{ id: null, name: '전체' },
					{ id: 1, name: '노출' },
					{ id: 2, name: '미노출' },
				],
				isDisplay: null,
				eventDateRange: { from: '', to: '' },
				isHiddenList,
				isHidden: isHiddenList[0].id,
				offset: 0,
				orderList: [
					{ id: 1, name: '최근등록순' },
					{ id: 2, name: '이전등록순' },
					{ id: 3, name: '댓글많은순' },
					{ id: 4, name: '댓글적은순' },
					{ id: 5, name: '참여많은순' },
					{ id: 6, name: '참여적은순' },
				],
				order: 1,
				limit: 10,
				totalItem: 0,
				totalList: [],
				list: [],
			};
		},
		computed: {
			...mapGetters({
				getListAddNull: 'getListAddNull',
				limitList: 'getLimitList',
				getItemById: 'getItemById',
			}),
		},
		watch: {
			'$route.query'() {
				this.getData();
			},
		},
		mounted() {
			this.setFilter();
			this.getData();
		},
		methods: {
			formatDate(time) {
				return moment(time * 1000).format('YYYY-MM-DD HH:mm');
			},
			setFilter() {
				const query = this.$route.query;
				this.paramsKeys.forEach(key => {
					const value = query[key];
					if (
						value &&
						[
							'eventType',
							'prerequisiteType',
							'clientType',
							'progress',
							'isDisplay',
							'offset',
							'order',
							'limit',
							'isHidden',
						].includes(key)
					) {
						this[key] = Number(value);
					} else if (
						value &&
						['eventTitle', 'clientName'].includes(key)
					) {
						this[key] = value;
					} else if (value && key === 'eventDateRange') {
						const eventDateRange = (value || ',').split(',');
						this.eventDateRange = {
							from: eventDateRange[0],
							to: eventDateRange[1],
						};
					}
				});
			},
			getParams() {
				return this.paramsKeys.reduce((acc, key) => {
					const value = this[key];
					if (
						['offset', 'order', 'limit'].includes(key) ||
						(value &&
							[
								'eventType',
								'prerequisiteType',
								'clientType',
								'progress',
								'isDisplay',
								'eventTitle',
								'clientName',
							].includes(key)) ||
						(key === 'isHidden' && typeof value === 'number')
					) {
						acc[key] = value;
					} else if (
						key === 'eventDateRange' &&
						(value.from || value.to)
					) {
						const eventDateRange = [value.from || 0];
						if (value.to) {
							eventDateRange[1] = value.to;
						}
						acc[key] = eventDateRange.map((date, idx) => {
							return date
								? idx === 0
									? moment(date, 'YYYY-MM-DD').format('x')
									: moment(date, 'YYYY-MM-DD')
											.endOf('date')
											.format('x')
								: date;
						});
					}
					return acc;
				}, {});
			},
			async getTotal(params) {
				const {
					data: { totalData },
				} = await this.$axiosAdmin2.post(
					'/api/eventList/total',
					params
				);
				this.totalItem = totalData.event_total;
				this.totalList = compact([
					totalData.soonProgress
						? `- 진행예정 ${totalData.soonProgress}건 (노출 ${totalData.soonProgress_display}건 / 미노출 ${totalData.soonProgress_nonDisplay}건)`
						: '',
					totalData.progress
						? `- 진행중 ${totalData.progress}건 (노출 ${totalData.progress_display}건 / 미노출 ${totalData.progress_nonDisplay}건)`
						: '',
					totalData.progressComplete
						? `- 종료 ${totalData.progressComplete}건 (노출 ${totalData.progressComplete_display}건 / 미노출 ${totalData.progressComplete_nonDisplay}건)`
						: '',
				]);
			},
			async getList(params) {
				const {
					data: { data },
				} = await this.$axiosAdmin2.post('/api/eventList', params);
				this.list = data.map(item => ({
					...item,
					createdDate: item.createdDate
						? this.formatDate(item.createdDate)
						: '-',
					isHidden: item.isHidden ? '히든' : '일반',
					eventType: item.eventType,
					startDate: item.startDate,
					endDate: item.endDate,
					progress: item.progress,
					clientName: item.clientType,
					eventType: item.eventType
						? this.getItemById('eventType', item.eventType).name
						: '-',
					prerequisiteType: item.prerequisiteType
						? this.getItemById(
								'prerequisiteType',
								item.prerequisiteType
							)?.name
						: '-',
					startDate: item.startDate
						? this.formatDate(item.startDate)
						: '-',
					endDate: item.endDate ? this.formatDate(item.endDate) : '-',
					progress: item.progress
						? this.progressList.find(
								progressItem =>
									progressItem.id === item.progress
							).name
						: '-',
					isDisplay: item.isDisplay === true ? '노출' : '미노출',
					clientName:
						item.clientType === 1
							? `글로우픽(${item.clientName})`
							: item.clientName,
				}));
			},

			async getData() {
				try {
					const params = this.getParams();
					await Promise.all([
						this.getTotal(params),
						this.getList(params),
					]);
				} catch (err) {
					console.error(err);
				}
			},
			valueChange(type, value) {
				this[type] = value;
			},
			replaceQuery() {
				const query = this.paramsKeys.reduce((acc, key) => {
					const value = this[key];
					if (['offset', 'order', 'limit'].includes(key)) {
						acc[key] = String(value);
					} else if (
						value &&
						[
							'eventType',
							'prerequisiteType',
							'clientType',
							'progress',
							'isDisplay',
						].includes(key)
					) {
						acc[key] = String(value);
					} else if (
						value &&
						['eventTitle', 'clientName'].includes(key)
					) {
						acc[key] = value;
					} else if (key === 'eventDateRange') {
						acc[key] = `${value.from},${value.to}`;
					} else if (
						key === 'isHidden' &&
						typeof value === 'number'
					) {
						acc[key] = String(value);
					}
					return acc;
				}, {});
				this.$router.replace({ query }).catch(() => {
					window.location.reload();
				});
			},
			search(offset = 0) {
				this.offset = offset;
				this.replaceQuery();
			},
			init() {
				this.eventType = null;
				this.prerequisiteType = null;
				this.eventTitle = '';
				this.clientType = null;
				this.progress = null;
				this.isDisplay = null;
				this.eventDateRange = { from: '', to: '' };
				this.isHidden = this.isHiddenList[0].id;
			},
			async excelDownload() {
				const params = this.getParams();
				delete params.limit;
				const { data, config } = await this.$axiosAdmin2.post(
					'/api/eventList/exportExcel',
					null,
					{ params }
				);
				const rows = data.data.map(item => [
					item.idEvent,
					this.formatDate(item.createdDate),
					item.isHidden ? '히든' : '일반',
					item.eventType
						? this.getItemById('eventType', item.eventType).name
						: '',
					item.eventTitle,
					item.prerequisiteType
						? this.getItemById(
								'prerequisiteType',
								item.prerequisiteType
							).name
						: '',
					item.clientName,
					this.formatDate(item.startDate),
					this.formatDate(item.endDate),
					item.winnerLimit,
					item.hitsCount,
					item.replyCount,
					item.candidateCount,
				]);
				const fileName = `이벤트리스트${moment().format('YYYYMMDD')}`;
				Util.getCsv(
					[rows],
					[fileName],
					[
						[
							'번호',
							'등록일시',
							'유형',
							'구분',
							'이벤트명',
							'참여조건',
							'클라이언트',
							'시작일시',
							'종료일시',
							'당첨인원',
							'조회수',
							'댓글수',
							'참여자수',
						],
					],
					fileName,
					config.url
				);
			},
			async deleting(id) {
				if (!confirm('정말 삭제하시겠습니까?')) {
					return;
				}
				try {
					await this.$axiosAdmin2.delete(`/api/eventList/${id}`);
					this.getData();
				} catch (err) {
					console.error(err);
				}
			},
			async duplicate(name, id) {
				try {
					if (!confirm(`이벤트 "${name}" 을 복제하시겠습니까?`))
						return;
					const {
						data: { data: detail },
					} = await this.$axiosAdmin2.get(`/api/events/${id}`);

					const idRegister = getIdRegister();

					const eventProduct = {
						idProducts: detail.products.reduce((acc, product) => {
							acc.push(product.idProduct);
							return acc;
						}, []),
					};
					const eventBrands = detail.brands?.map(
						({ idBrand: brandId }) => ({ brandId })
					);

					const eventQuestionList = detail.eventQuestionList?.map(
						({ applyType, options }) => ({ applyType, options })
					);

					const eventCategories = detail.categories?.map(
						({
							idFirstCategory,
							idSecondCategory,
							idThirdCategory,
						}) => ({
							idFirstCategory,
							idSecondCategory,
							idThirdCategory,
						})
					);

					const eventContent = {
						eventText: '',
						fileDir: '/event/3a2',
						fileOrgName: 'image.png',
						fileSaveName:
							'3a2bfe20-d27d-11ed-be9e-0101574d30b7.png',
						fileSize: 13883,
						fileType: 'image/png',
						path: '/event/3a2/3a2bfe20-d27d-11ed-be9e-0101574d30b7.png',
					};

					const params = {
						idEvent: null,
						isDisplay: false,
						eventTitle: detail.eventTitle,
						eventDesc: detail.eventDesc,
						startDate: detail.startDate,
						endDate: detail.endDate,
						clientType: 1,
						clientName: null,
						idBrand: null,
						isReply: detail.isReply,
						replyHolderText: detail.replyHolderText,
						eventType: detail.eventType,
						activityDate: detail.activityDate,
						prerequisiteType: detail.prerequisiteType,
						isAllDate: detail.isAllDate,
						prerequisiteStartDate: detail.prerequisiteStartDate,
						prerequisiteEndDate: detail.prerequisiteEndDate,
						prerequisiteTarget: detail.prerequisiteTarget,
						prerequisiteLimit: detail.prerequisiteLimit,
						btnLinkText: detail.btnLinkText,
						linkType: detail.linkType ?? '44',
						linkValue: detail.linkValue,
						idRegister,
						thirdAgreeCompany: detail.thirdAgreeCompany,
						thirdAgreePurpose: detail.thirdAgreePurpose,
						thirdAgreeInfo: detail.thirdAgreeInfo,
						thirdAgreeDate: detail.thirdAgreeDate,
						hitsCount: 0,
						winnerLimit: null,
						winnerIssueOn: detail.winnerIssueOn,
						alertNoReviewStartOn: detail.alertNoReviewStartOn,
						alertNoReviewEndOn: detail.alertNoReviewEndOn,
						isHidden: detail.isHidden,
						eventProduct,
						eventBrands:
							detail.prerequisiteType === 6 &&
							detail.prerequisiteTarget === 'BRAND_TARGET'
								? eventBrands
								: [],
						isDelete: false,
						eventQuestionList,
						eventCategories: eventCategories ?? [],
						eventContent,
						reviewEndAt: detail.reviewEndAt,
					};

					this.$store.commit('toggleSpinner', true);
					const { data } = await this.$axiosAdmin2.post(
						'/api/events',
						params
					);
					alert(data.msg || '복제 성공!');
					this.offset = 0;
					this.$router.replace('/events/list').catch(() => {
						window.location.reload();
					});
				} catch (err) {
					console.error(err);
					alert(
						`이벤트 "${name}" 복제 실패했습니다. 개발팀에 문의하세요.`
					);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.event__filter__client {
		display: flex;
		width: 100%;
		align-items: top;
	}

	.event__filter__client__type {
		width: 112px;
		margin-right: 20px;
		flex-shrink: 0;
	}

	.event__total__item {
		display: block;
		line-height: 14px;
		color: #222;
		font-size: 0.875rem;
		font-weight: 700;
	}

	.event__total__item--sub {
		font-weight: 400;
	}

	.event__table {
		th,
		td {
			white-space: nowrap;
		}

		.event__table__name {
			min-width: 200px;
		}

		.event__table__link {
			white-space: normal;
		}
	}
</style>
